import React from 'react';
import ReactExport from 'react-data-export';
import { Order } from '../interfaces';
import { Button, IconButton } from '@material-ui/core';
import Icon from '@mdi/react';
import { mdiTableArrowUp, mdiFileExcelOutline } from '@mdi/js';
import jMoment from 'moment-jalaali';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const dataSet1 = [
  {
    name: 'Johson',
    amount: 30000,
    sex: 'M',
    is_married: true,
  },
  {
    name: 'Monika',
    amount: 355000,
    sex: 'F',
    is_married: false,
  },
  {
    name: 'John',
    amount: 250000,
    sex: 'M',
    is_married: false,
  },
  {
    name: 'Josef',
    amount: 450500,
    sex: 'M',
    is_married: true,
  },
];

const dataSet2 = [
  {
    name: 'Johnson',
    total: 25,
    remainig: 16,
  },
  {
    name: 'Josef',
    total: 25,
    remainig: 7,
  },
];

interface Props {
  data: Order[];
}

const ExelExport = ({ data }: Props) => {
  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {
        ...item,
        deliveryDateFa:
          item.deliveryDate &&
          jMoment(item.deliveryDate, 'YYYY/M/D')
            .locale('fa')
            .format('jYY/jMM/jDD'),
        deliveryDate: item.deliveryDate,
        customerMobileNumber: item.customerMobileNumber + '',
        packages: undefined,
      };
    });
    return newData;
  };

  if (data.length > 0) {
    return (
      <ExcelFile
        element={
          <IconButton
            style={{
              border: '2px solid ',
              marginLeft: '5px',
              borderRadius: '5px',
              backgroundColor: '#2F4858',
            }}
          >
            <Icon
              path={mdiFileExcelOutline}
              size={1}
              style={{ color: 'white' }}
            />
          </IconButton>
        }
      >
        <ExcelSheet data={flattData(data)} name="orders">
          {data &&
            Object.entries(flattData(data)[0])?.map(el => {
              return <ExcelColumn label={el[0]} value={el[0]} />;
            })}
        </ExcelSheet>
      </ExcelFile>
    );
  }
  else {
    return (
      <IconButton
        disabled={data ? true : false}
        style={{
          border: '2px solid ',
          marginLeft: '5px',
          borderRadius: '5px',
          backgroundColor: '#2F4858',
        }}
      >
        <Icon path={mdiFileExcelOutline} size={1} style={{ color: 'white' }} />
      </IconButton>
    );
  }
};

export default ExelExport;
